import React from 'react';
import PropTypes from 'prop-types';
import ErrorPage from './pages/ErrorPage';

export default class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.object
  };

  state = { error: null }

  componentDidCatch(error, info) {
    this.setState({ error });

    if (typeof window !== 'undefined' && window.env.SENTRY_DSN) {
      /* eslint-disable global-require */
      const LoggingService = require('../services/LoggingService.client');

      LoggingService.captureMessage('componentDidCatchError', {
        err: error,
        extra: info
      });
    }
  }

  render() {
    return this.state.error ?
      <ErrorPage error={this.state.error} /> :
      this.props.children;
  }
}
